var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2074_16023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3102 47.58C15.3102 47.58 24.9102 39.67 29.4302 39.96L31.6902 64.24L14.4702 66.78L15.3202 47.58H15.3102Z",
    fill: "#EC5569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 43.01H26.9499C28.0499 43.01 28.9499 43.91 28.9499 45.01V61.09C28.9499 62.19 28.0499 63.09 26.9499 63.09H20.9199V43.01Z",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 43.01H20.9199V63.09H15.8799C13.1199 63.09 10.8799 60.85 10.8799 58.09V48.01C10.8799 45.25 13.1199 43.01 15.8799 43.01Z",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0698 63.08H55.0398C53.9398 63.08 53.0398 62.18 53.0398 61.08V45C53.0398 43.9 53.9398 43 55.0398 43H61.0698V63.08Z",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1099 63.08H61.0699V43H66.1099C68.8699 43 71.1099 45.24 71.1099 48V58.08C71.1099 60.84 68.8699 63.08 66.1099 63.08Z",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9502 14.11C32.4902 12.06 36.6102 10.89 41.0002 10.89C54.3102 10.89 65.0902 21.68 65.0902 34.98V43.01",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9102 43.01V34.98C16.9102 28.81 19.2302 23.18 23.0502 18.92",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0898 63.09V67.11C65.0898 69.33 63.2898 71.13 61.0698 71.13H45.0098",
    stroke: "#060606",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_16023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.ac9f557c6d54aafad5f000c04cde484d.svg";
export { ForwardRef as ReactComponent };